import { myToolbar } from '../tools/toolbar.js';
import { settings } from '../settings.js';
import { starConfig } from './star.js';
import { triangleConfig } from './triangle.js';
import { squareConfig } from './square.js';
import { loomBrickPeyoteConfig } from './loomBrickPeyote.js';
import { huicholConfig } from './huichol.js';
import { rawConfig } from './raw.js';
import { medallionConfig } from './medallion.js';
import { plasticConfig } from './plastic.js';
import { beads } from '../beads.js';

export const patterns = {};

// all the patterns that exist in the software
patterns.arr = loomBrickPeyoteConfig
    .concat([
        rawConfig,
        triangleConfig,
        squareConfig,
        starConfig,
        huicholConfig,
        medallionConfig,
    ]).concat(plasticConfig);

// called on start.newProject
patterns.newProject = config => {
    if (settings.pattern.newProject) {
        settings.pattern.newProject(config);
    }

    if (settings.pattern.arrangeGrid) {
        patterns.arrangeGrid()
    }

    if (settings.pattern.apply) {
        settings.pattern.apply();
    }

    ['Row Shift', 'Bead Mode', 'Paint', 'Star'].forEach(toolName => {
        if (settings.pattern.disabledTools.includes(toolName)) {
            myToolbar.disableTool(toolName);
        } else {
            myToolbar.enableTool(toolName);
        }
    });
};

patterns.arrangeGrid = () => {

    const colDist = settings.pattern.colDist();
    const rowDist = settings.pattern.rowDist();
    const offset = settings.pattern.offset();
    const offsetPattern = settings.pattern.offsetPattern;

    let counter = 1;

    beads.arr.forEach(bead => {
        if (counter === offsetPattern.length) counter = 0;
        if (bead.row === 0) counter = 0;

        if (beads.rowOffset[bead.row] === null) {
            beads.rowOffset[bead.row] = offsetPattern[counter];
        }

        bead.x = 100 + (bead.column * colDist) + (offset * beads.rowOffset[bead.row]);
        bead.y = +(100 + (bead.row * rowDist)).toFixed(2);

        counter++;
    });
};

// called (for example) on new project and edit project pages
patterns.getRowsAndColumns = ({pattern, rows, columns, size}) => {

    // limit crazy sizes people might put in
    rows = Math.min(rows, pattern.rowLimit || 400);
    columns = Math.min(columns, 400);

    if (pattern.getRowsAndColumns) {
        [rows, columns] = pattern.getRowsAndColumns({rows, columns, size})
    }

    return { rows, columns };
};
